// #225: hand off to Epoch's HOSTED payment page via a full same-tab redirect, instead of
// embedding Epoch's page in an in-app <iframe> (which fought the mobile viewport). The
// redirectURL always originates from our own backend (createEpochApiCall → invoice-push),
// so it's trusted; we still guard against an empty/missing URL.
export function redirectToCheckout(redirectURL?: string): boolean {
  if (!redirectURL) return false
  window.location.assign(redirectURL)
  return true
}
